import { useState, useEffect } from 'react';

const useTabVisibility = (clearAction: Function = () => {}) => {
  const [isTabActive, setIsTabActive] = useState(true);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsTabActive(false);
      clearAction()
    };

    window.addEventListener('blur', handleVisibilityChange);
    window.removeEventListener('focus', handleVisibilityChange)

    return () => {
      window.removeEventListener('blur', handleVisibilityChange);
      window.removeEventListener('focus', handleVisibilityChange)
    };
  }, []);


  return {
    isTabActive,
  };
};

export default useTabVisibility;
